'use strict';
module.exports = require('../../full/symbol');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/symbol/index.js
// module id = 1236
// module chunks = 0